import { computed, isRef, ref, unref } from 'vue'
import LocalStorageEncoder from '@/utils/Encoders/LocalStorageEncoder'

/**
 * A simple wrapper around the LocalStorageEncoder object. Makes it easy to work with simple single variables that are bound
 * to the url query parameters and saved in the local storage.
 * @param name
 * @param def
 * @param decoderTransformer
 */
export default function useLocalStorageEncoder(
  name: string,
  def: any = null,
  decoderTransformer: any = null,
  encoderTransformer: any = null,
) {
  const holder = isRef(def) ? def : ref(def)

  const eEncoder = new LocalStorageEncoder({
    queryPoint: name,
    decodeOnPop: true,
    defaultVal: unref(def),
    addQueryKeyByDefault: false,
    decoder: ((raw, enc) => {
      const res = typeof decoderTransformer === 'function' ? decoderTransformer(raw, enc) : raw
      holder.value = res
      return res
    }) as any,
    encoder: encoderTransformer,
  })

  return computed({
    get() {
      return holder.value
    },
    set(val) {
      holder.value = val
      eEncoder.data = val
    },
  })
}
